import { useShallow } from 'zustand/shallow';

import { StagesState, store } from './store';

export const useStages = () => {
  const {
    count,
    data: stages,
    error,
    changeCandidateCount,
    fetchStages,
    loading,
    reset,
    createStage,
    renameStage,
  } = store<StagesState>(
    useShallow((state) => ({
      data: state.data,
      count: state.count,
      error: state.error,
      loading: state.loading,
      changeCandidateCount: state.changeCandidateCount,
      fetchStages: state.fetchStages,
      createStage: state.createStage,
      reset: state.reset,
      renameStage: state.renameStage,
    })),
  );
  return {
    error,
    loading,
    count,
    stages,
    changeCandidateCount,
    fetchStages,
    reset,
    createStage,
    renameStage,
  };
};
